import React, {CSSProperties, FC, ReactNode, useId} from 'react';
import classNames from 'classnames';
import style from './style.module.scss';
import {MIN_DESKTOP_WIDTH} from 'core/constants';

interface IProps {
    isContainer?: boolean;
    children: ReactNode;
    displayType?: CSSProperties['display'];
}

export const OnlyMobile: FC<IProps> = ({displayType = 'block', children, isContainer = false}) => {
    const uid = useId().replaceAll(/\W/gu, '_');
    return (
        <>
            <style>{`.${uid} {
                    display: ${displayType};
                    
                    @media (min-width: ${MIN_DESKTOP_WIDTH}px) {
                        display: none
                    }
            }`}</style>
            <div
                className={classNames(
                    style.wrapper,
                    {
                        [style.isContainer]: isContainer,
                    },
                    uid,
                )}
            >
                {children}
            </div>
        </>
    );
};
